module.exports = __webpack_public_path__ + "static/buttonActivate-638554cdfb1af8d6679281c5c2154ecf.png";